"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _styledMediaQuery = _interopRequireDefault(require("styled-media-query"));

var _gatsbyImage = _interopRequireDefault(require("gatsby-image"));

var _Box = _interopRequireDefault(require("@material-ui/core/Box"));

var _Grid = _interopRequireDefault(require("@material-ui/core/Grid"));

var _Typography = _interopRequireDefault(require("@material-ui/core/Typography"));

var _styles = require("@material-ui/core/styles");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n    width: 90px;\n  "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n    width: 140px;\n  "]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var useStyle = (0, _styles.makeStyles)(function (theme) {
  var _root;

  return {
    root: (_root = {
      height: '100%',
      flexDirection: 'column',
      justifyContent: 'space-between'
    }, _defineProperty(_root, theme.breakpoints.down('sm'), {
      flexDirection: 'row',
      '& > div': {
        minWidth: '50%',
        width: '50%'
      }
    }), _defineProperty(_root, theme.breakpoints.down('xs'), {
      '&  > div': {
        minWidth: '100%',
        width: '100%'
      }
    }), _root),
    headline: {
      fontSize: '2.083rem',
      lineHeight: '1.2',
      marginBottom: theme.spacing(2),
      marginTop: theme.spacing(4),
      width: '87.5%'
    },
    text: {
      fontSize: '0.885rem',
      lineHeight: '1.7',
      marginTop: theme.spacing(4)
    }
  };
});
var LogoContainer = (0, _styledComponents["default"])(_gatsbyImage["default"]).withConfig({
  displayName: "Spotlight__LogoContainer",
  componentId: "sc-1943hmw-0"
})(["height:85px;width:180px;", " ", ""], _styledMediaQuery["default"].lessThan('large')(_templateObject()), _styledMediaQuery["default"].lessThan('medium')(_templateObject2()));

var Spotlight = function Spotlight(_ref) {
  var children = _ref.children,
      color = _ref.color,
      title = _ref.title,
      description = _ref.description,
      logo = _ref.logo;
  var cls = useStyle();
  return /*#__PURE__*/_react["default"].createElement(_Box["default"], {
    p: 3,
    height: "100%"
  }, /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
    spacing: 3,
    className: cls.root,
    container: true
  }, /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
    item: true
  }, /*#__PURE__*/_react["default"].createElement(LogoContainer, {
    fluid: {
      src: logo
    },
    alt: "Logo",
    imgStyle: {
      objectPosition: 'left',
      objectFit: 'contain'
    }
  }), /*#__PURE__*/_react["default"].createElement(_Typography["default"], {
    className: cls.headline,
    variant: "h2",
    style: {
      color: color
    }
  }, title)), /*#__PURE__*/_react["default"].createElement(_Grid["default"], {
    item: true
  }, /*#__PURE__*/_react["default"].createElement(_Box["default"], {
    m: "0 auto",
    maxWidth: 300,
    textAlign: "center",
    p: 2
  }, children, /*#__PURE__*/_react["default"].createElement(_Typography["default"], {
    className: cls.text,
    style: {
      color: color
    }
  }, description)))));
};

Spotlight.defaultProps = {
  color: undefined
};
Spotlight.propTypes = {
  children: _propTypes["default"].oneOfType([_propTypes["default"].node, _propTypes["default"].object]).isRequired,
  color: _propTypes["default"].string,
  logo: _propTypes["default"].string.isRequired,
  title: _propTypes["default"].string.isRequired,
  description: _propTypes["default"].string.isRequired
};
var _default = Spotlight;
exports["default"] = _default;